import PropTypes from 'prop-types';
// @ts-expect-error
import React from 'react';
import ReactDOM from 'react-dom';

import { usePopperTooltip } from 'shared/ui/Popper';

function PopperTooltip({ children, overlay, ...rest }) {
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
    placement: 'bottom',
    trigger: 'hover',
    ...rest,
  });

  return (
    <>
      <div className="tooltip-wrapper-box" ref={setTriggerRef}>
        {children}
      </div>

      {overlay &&
        visible &&
        ReactDOM.createPortal(
          <div
            ref={setTooltipRef}
            {...getTooltipProps({
              className: 'tooltip-container tooltip-popper',
            })}
          >
            {overlay}
            <div {...getArrowProps({ className: 'tooltip-arrow' })} />
          </div>,
          document.body,
        )}
    </>
  );
}

PopperTooltip.propTypes = {
  placement: PropTypes.string,
  overlay: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

// eslint-disable-next-line import/no-default-export
export default PopperTooltip;
